import React from "react";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const NoPaddingBtnWithIcons = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"noPadding button with start and end icon"}
        value={
          '<Button variant={"noPadding"} color={"inherit"} startIcon={<ArrowLeftIcon />} endIcon={<ArrowRightIcon />}>\n' +
          "            Label\n" +
          "          </Button>"
        }
      >
        <Button
          variant={"noPadding"}
          color={"inherit"}
          startIcon={<ArrowLeftIcon />}
          endIcon={<ArrowRightIcon />}
        >
          Label
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default NoPaddingBtnWithIcons;
